import Vue from 'vue';
import Vuex from 'vuex';
import http from '@/common/http';
import router from '../../router';

import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);
const state = {
  strict: process.env.NODE_ENV !== 'production',
  global_loading: false,

  //全局变量
  user: {},
  customer: {},
  logo_url: '',
  department: {},
  menus: [],
  buttonJSON: {},
  dictJson: null,
  dictJsonAll: null,
  actions: [],
  eqs: [],
  eqPoints: [],
  customers: [],
  wmsCustomers: [],
  customerUsers: [],
  customerRoles: [],
  organizations: [],
  subOrganizations: [],
  pcds: [],
  warehouses: [],
  defectTypes: [],
  mouths: [],
  workshops: [],
  workshopsMap: {},
  equipmentsMap: {},
  currentTime: '',
  //只持久化token和lang和monitorSetting

  //基础数据是否已加载完全(指首次)
  is_base_data_ready: false,

  router_tabs: [],
  router_names: [],
  is_sidebar_open: true,
  is_monitor_full: false,
  sidebar_arr: [],
  window_inner_height: 0,
  router_view_height: 0,
  router_view_width: 0
};
export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.localStorage,
      reducer(val) {
        return {
          // token不储存了，不同tab直接会竞争
          //monitorSetting:val.monitorSetting,
        };
      }
    })
  ],
  state,
  mutations: {
    SET_CURRENT_TIME(state, time) {
      state.currentTime = time;
    },
    SET_BASE_DATA_READY(state, b) {
      state.is_base_data_ready = b;
    },
    SET_GLOBAL_LOADING(state, b) {
      state.global_loading = b;
    },
    SET_ACTIONS(state, actions) {
      state.actions = actions;
    },
    SET_USER(state, user) {
      state.user = user;
      window.localStorage.setItem('userId', user.id);
    },
    SET_CUSTOMER(state, customer) {
      state.customer = customer;
      if (customer.id != null) {
        window.localStorage.setItem('customerId', customer.id);
      } else {
        window.localStorage.removeItem('customerId');
      }
    },
    SET_LOGO_URL(state, url) {
      state.logo_url = url;
    },
    SET_WMS_CUSTOMER(state, wmsCustomers) {
      state.wmsCustomers = wmsCustomers;
    },
    SET_CUSTOMER_USER(state, customerUsers) {
      state.customerUsers = customerUsers;
    },

    SET_DEPARTMENT(state, department) {
      state.department = department;
    },
    SET_MENUS(state, menus) {
      state.menus = menus;
    },
    SET_EQS(state, eqs) {
      state.eqs = eqs;
    },
    SET_EQ_POINTS(state, eqPoints) {
      state.eqPoints = eqPoints;
    },

    SET_CUSTOMERS(state, customers) {
      state.customers = customers;
    },
    SET_CUSTOMER_ROLES(state, customerRoles) {
      state.customerRoles = customerRoles;
    },
    SET_ORGANIZATIONS(state, organizations) {
      state.organizations = organizations;
    },
    SET_SUB_ORGANIZATIONS(state, subOrganizations) {
      state.subOrganizations = subOrganizations;
    },
    SET_PCDS(state, pcds) {
      state.pcds = pcds;
    },
    SET_WAREHOUSE(state, warehouses) {
      state.warehouses = warehouses;
    },

    SET_DEFECT_TYPES(state, defectTypes) {
      state.defectTypes = defectTypes;
    },
    SET_MOUTHS(state, mouths) {
      state.mouths = mouths;
    },
    SET_BUTTONJSON(state, buttonJSON) {
      state.buttonJSON = buttonJSON;
    },
    SET_DICTJSON(state, dictJson) {
      state.dictJson = dictJson;
    },
    SET_DICTJSON_ALL(state, dictJson) {
      state.dictJsonAll = dictJson;
    },
    SET_CUSTOMER_TABLE_FIELDS(state, customerTableFields) {
      state.customerTableFields = customerTableFields;
    },
    // 退出登录时清空缓存
    deleteWorkshopsAndEquipmentMtt(state) {
      console.log('deleteWorkshopsAndEquipmentMtt');
      state.workshops = [];
      state.workshopsMap = {};
      state.equipmentsMap = {};
    },
    //添加车间,车间中包含了设备和对应的showjosn和点表
    updateWorkshopsMtt(state, workshops) {
      state.workshops = workshops;
      let tempWorkshopsMap = {};
      let tempEquipmentsMap = {};
      workshops.forEach(ws => {
        tempWorkshopsMap[ws.code] = ws;
        ws.equipments.forEach(eq => {
          tempEquipmentsMap[eq.equipmentSn] = eq;
        });
      });
      state.workshopsMap = tempWorkshopsMap;
      state.equipmentsMap = tempEquipmentsMap;
    },

    //更新车间的data,可传入车间的code或者在workshops中的index
    updateWorkshopsDataMtt(state, { code, index, data }) {
      if (code !== undefined) {
        state.workshopsMap[code].data = Object.assign({}, state.workshopsMap[code].data, data);
      } else if (index !== undefined) {
        state.workshops[index].data = Object.assign({}, state.workshops[index].data, data);
      } else {
        console.error('updateWorkshopsDataMtt传参错误,code和index均为undefined');
      }
    },

    //更新所有设备数据
    updatePointMtt(state, tempEquipmentsMap) {
      console.log('updatePointMtt 开始');
      //用新地址的对象(其实内容和state中存储自身的内容是一模一的)赋值,可以触发equipmentsMap和workshops的页面更新渲染.
      state.equipmentsMap = tempEquipmentsMap;
      state.workshops = [...state.workshops];
      console.log('updatePointMtt 结束');
    },
    //更新单个设备
    updateSingleEqMtt(state, eq) {
      state.equipmentsMap[eq.equipmentSn] = eq;
    },

    SET_IS_SIDEBAR_OPEN(state, b) {
      state.is_sidebar_open = b;
    },
    SET_WINDOW_INNER_HEIGHT(state, b) {
      state.window_inner_height = b;
    },
    SET_ROUTER_VIEW_HEIGHT(state, b) {
      state.router_view_height = b;
    },
    SET_ROUTER_VIEW_WIDTH(state, b) {
      state.router_view_width = b;
    },
    TO_ROUTER_TABS(state, to_from) {
      var to = to_from[0];
      var from = to_from[1];

      for (var i = 0; i < state.router_tabs.length; i++) {
        if (state.router_tabs[i].path == to.path) {
          //已存在就return
          return;
        }
      }
      state.router_tabs.push({
        path: to.path,
        name: to.meta.name,
        componentName: to.meta.componentName,
        link: to.meta.link
      });
    },
    DELETE_ROUTER_TAB(state, deleted) {
      var deleted = deleted;
      var current = state.route.path;

      console.log(deleted, current);
      for (var i = 0; i < state.router_tabs.length; i++) {
        if (state.router_tabs[i].path == deleted) {
          if (deleted == current) {
            //删除的是正在显示的
            if (i == state.router_tabs.length - 1) {
              //删最后一个的话，删除后，跳到前一个
              var pre = state.router_tabs[i - 1];
              state.router_tabs.splice(i, 1);
              i--;
              router.push(pre.path);
            } else {
              //不是删最后一个的话，删除后，跳到后一个
              var next = state.router_tabs[i + 1];
              state.router_tabs.splice(i, 1);
              i--;
              router.push(next.path);
            }
          } else {
            //如果被删除的路由非正在显示的，那么就不改变路由
            state.router_tabs.splice(i, 1);
            i--;
          }

          break;
        }
      }
    }
  },
  actions: {
    //负责数据的中间处理
    // 初始化指定部门的车间列表,并加载车间的设备列表,并加载设备的模板和showJson
    addWorkshops({ commit }, departmentCode) {
      return new Promise(async resolve => {
        let workshops = await Vue.prototype.http.get(`/customer/department/${departmentCode}/workshop`);
        //删除多余的属性,减少vuex内对象的大小,提高页面性能
        for (let i = 0; i < workshops.length; i++) {
          let ws = workshops[i];
          delete ws.version;
          delete ws.gmtCreate;
          delete ws.gmtModified;
          delete ws.customerCode;
          delete ws.parentId;
          delete ws.level;
        }

        let proArr = []; //所有promise请求
        let eqs = []; //暂存所有车间的设备,用于一次性调用接口传参
        let isEx = {};
        Promise.all(
          workshops.map(ws => {
            return Vue.prototype.http.get(`/customer/equipment/dept-code/${ws.code}`);
          })
        ).then(workshopResArr => {
          for (let i = 0; i < workshopResArr.length; i++) {
            let equipments = workshopResArr[i];
            //测试代码
            // equipments = equipments.slice(8, 9);
            let ws = workshops[i];

            ws.data = {};
            ws.equipments = equipments;
            eqs = eqs.concat(equipments);
            ws.equipments.forEach(eq => {
              //删除多余的属性,减少vuex内对象的大小,提高页面性能
              delete eq.customerId;
              delete eq.customerCode;
              delete eq.departmentId;
              delete eq.equipmentModelId;
              delete eq.manufacturer;
              delete eq.gatewaySn;
              delete eq.protocolId;
              delete eq.version;
              delete eq.version;
              eq.status = []; //设备当日状态

              let templatecode = eq.templateCode;
              let standardmodelcode = eq.standardModelCode;

              if (isEx[templatecode] == undefined || isEx[templatecode][standardmodelcode] == undefined) {
                isEx[templatecode] = isEx[templatecode] || {};
                isEx[templatecode][standardmodelcode] = [];
              }
              isEx[templatecode][standardmodelcode].push(eq);
            });
          }

          //统一查询showjson
          let params = eqs.map(eq => {
            return [eq.equipmentSn, eq.templateCode];
          });
          proArr.push(
            Vue.prototype.http.post('/customer/equipmentshow/getShowJsonByList', params).then(res => {
              eqs.forEach(eq => {
                eq.showJson = JSON.parse(res[eq.equipmentSn].showJson);
              });
            })
          );

          //合并查询template
          for (let templateCode in isEx) {
            for (let standardModelCode in isEx[templateCode]) {
              let eqArr = isEx[templateCode][standardModelCode];
              proArr.push(
                Vue.prototype.http
                  .get(
                    `/customer/pointtemplatedetail/listByParams?` +
                      Vue.prototype.qs.stringify({
                        templateCode,
                        standardModelCode
                      }),
                    {
                      //isJson: true 下面copy了一次，所以不需要这个
                    }
                  )
                  .then(points => {
                    for (let eq of eqArr) {
                      //构造新的点,否则不同设备会共享相同点值
                      let newPoints = Vue.prototype.utils.copy(points);
                      eq.cmsCodePointsMap = {};
                      eq.codePointsMap = {};
                      newPoints.forEach(p => {
                        //删除多余的属性,减少vuex内对象的大小,提高页面性能
                        delete p.gmtCreate;
                        delete p.gmtModified;
                        for (let i in p) {
                          if (p[i] == '') {
                            delete p[i];
                          }
                        }

                        eq.codePointsMap[p.code] = p;
                        eq.cmsCodePointsMap[p.cmsCode] = p;
                      });

                      console.log(eq.codePointsMap);
                    }
                  })
              );
            }
          }
          Promise.all(proArr).then(() => {
            commit('updateWorkshopsMtt', workshops);
            resolve();
          });
        });
      });
    },

    // 更新设备统计数据
    refreshEqData({ commit, state }, { snPointArr, delay }) {
      return new Promise(resolve => {
        /////uni.showLoading();
        let currentTime = new Date().getTime();
        let paramArr1 = [];
        let paramArr3 = [];
        let tempEquipmentsMap = { ...state.equipmentsMap };

        for (let item of snPointArr) {
          let sn = item.sn;
          let node1 = [];
          let node3 = [];
          for (let code of item.nodes) {
            let source = tempEquipmentsMap[sn].codePointsMap[code].source;
            if (source == 1) {
              node1.push(tempEquipmentsMap[sn].codePointsMap[code].cmsCode);
            } else if (source == 3) {
              node3.push(tempEquipmentsMap[sn].codePointsMap[code].code);
            }
          }
          if (node1.length > 0) {
            paramArr1.push({
              sn,
              nodes: node1
            });
          }
          if (node3.length > 0) {
            paramArr3.push({
              sn,
              pointList: node3
            });
          }
        }

        let proArr = [];
        if (paramArr1.length > 0) {
          proArr.push(
            Vue.prototype.http.post(`/cms/data/instant`, JSON.stringify(paramArr1)).then(eqData => {
              for (let sn in eqData) {
                for (let cmsCode in eqData[sn]) {
                  let point = JSON.parse(eqData[sn][cmsCode]);
                  if (tempEquipmentsMap[sn].cmsCodePointsMap[cmsCode]) {
                    tempEquipmentsMap[sn].cmsCodePointsMap[cmsCode].v = point.v;
                    tempEquipmentsMap[sn].cmsCodePointsMap[cmsCode].t = point.t;
                  }
                }
              }
            })
          );
        }
        if (paramArr3.length > 0) {
          proArr.push(
            Vue.prototype.http.post(`/production/pointData/getPointData`, JSON.stringify(paramArr3)).then(eqData => {
              for (let sn in eqData) {
                for (let code in eqData[sn]) {
                  let point = eqData[sn][code];
                  if (tempEquipmentsMap[sn].codePointsMap[code]) {
                    tempEquipmentsMap[sn].codePointsMap[code].v = point;
                    tempEquipmentsMap[sn].codePointsMap[code].t = currentTime;
                  }
                }
              }
            })
          );
        }

        Promise.all(proArr).then(() => {
          setTimeout(() => {
            commit('updatePointMtt', tempEquipmentsMap);
            resolve();
            /////uni.hideLoading();
          }, delay || 0);
        });
      });
    }
  }
});
